<template>
    <div class="mylistwrap" v-if="isload">
        <div class="mylist" v-if="$common.basic.isarrayexist(infolist)">
            <dl class="avg listheader" v-if="!issmall">
                <dd v-if="isteaview">{{$common.dicword('username')}} </dd>
                <dd v-if="isteaview">{{$common.dicword('course')}}</dd>
                <dd>{{$common.dicword('topic')}}</dd>
                <dd>{{$common.dicword('uploadtime')}}</dd>
                <dd v-if="c_options.tk!=3">{{$common.dicword('stat')}}</dd>
                <dd>{{$common.dicword('operation')}}</dd>
            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="item in infolist" :key="item.id">
                    <dd v-if="isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('username',true)}}&nbsp;
                        </span>
                        <ffmember :username="item.username" :stuid="item.mid"></ffmember>
                    </dd>
                    <dd v-if="isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('course',true)}}&nbsp;
                        </span><router-link :to="'/course/'+item.courseid">{{$common.langinfo(item.coursetitle,item.coursetitle_en)}}</router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('topic',true)}}&nbsp;
                        </span><router-link :to="'/learn/'+(isteaview?item.topicid:item.id)">{{isteaview? $common.langinfo(item.topictitle,item.topictitle_en): $common.langinfo(item.title,item.title_en)}}</router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('uploadtime',true)}}&nbsp;
                        </span>
                        {{$common.basic.dateformat(item.x_hw.dateupload||'','yyyy-MM-dd hh:mm')}}
                    </dd>
                    <dd v-if="c_options.tk!=3">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('stat',true)}}&nbsp;
                        </span>
                        {{$common.basic.isobjexist(item.x_hw)? item.x_hw.isread?$common.dicword('workread'):$common.dicword('workwait'):'&nbsp;'}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('operation',true)}}&nbsp;
                        </span><a href="#" @click="gethw(item)">{{$common.dicword('viewdetail')}}</a>
                    </dd>
                </dl>
            </div>

            <div class="ffpage">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>
        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
        <el-dialog v-if="isshowdialog" :visible.sync="isshowdialog" top="0px" class="mydialogwork" append-to-body :show-close="canclose" :close-on-click-modal="canclose" :close-on-press-escape="canclose">
            <div class="hwdetail modulewrap">
                <div class="title">
                    {{$common.langinfo(infodatatopic.title,infodatatopic.title_en)}}
                </div>
                <div class="con">
                    <myScroll class="scroll">
                        <span v-html="$common.langinfo(infodatatopic.conhw,infodatatopic.conhw_en)"></span>
                        <div class="linkright" v-if="!(infodatahw.isread) && isstu">
                            <ffupload :fileurl="upfileurl" @update:fileurl="upattach" :updata="{'mediatype':'zip','filesize':100}" :uptitle="$common.dicword('uploadwork')"></ffupload>
                        </div>
                        <template v-if="$common.basic.isobjexist(infodatahw)">
                            <div class="linesp"></div>
                            <div class="attach">
                                <a :href="infodatahw.attach" target="_blank">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-yasuobao"></use>
                                    </svg>{{$common.basic.dateformat(infodatahw.dateupload)}}
                                </a>

                            </div>
                            <template v-if="infodatahw.conmark && infodatahw.isread==1">
                                <div class="hwbacktitle">{{$common.dicword('recommend')}}</div>
                                <div class="hwback" v-html="infodatahw.conmark">

                                </div>
                            </template>
                            <template v-if="c_options.tk==3 && infodatahw.isread==0">
                                <div class="linesp"></div>
                                <div class="input"><textarea v-model="infodatahw.conmark"></textarea></div>
                                <div class="inputbtn"><a href="#" class="btn1" @click="workmark">{{$common.dicword('submit')}}</a></div>
                            </template>
                        </template>
                    </myScroll>
                </div>
            </div>


        </el-dialog>
    </div>
</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin"
    export default {
        name: 'Cwork',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tea_t_work',
                isshowdialog: false,
                infodatahw: {},
                infodatatopic: {},
                upfileurl: '',
                topicid: 0,
            };
        },
        computed: {
            curtopic: function () {
                return this.$common.basic.fffind(this.infolist, 'id', this.topicid);
            },
            canclose: function () {
                return !(this.c_options.tk == 3 && !this.c_options.isdone);
            }
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {
                    let popitem = null;
                    this.$common.each(res.infodata, item => {
                        item.x_hw = this.isteaview ? item : this.$common.basic.fffind(res.infodatahw, 'topicid', item.id);
                        if ((item.teaid) && (this.c_options.tk == 3) && this.c_options.isdone == 0) {
                            popitem = item;
                        }
                    })
                    this.infolist = res.infodata;
                    this.isload = true;
                    this.res = res;
                    if (this.$common.basic.isobjexist(popitem)) {
                        this.gethw(popitem);
                    }
                });
            },
            gethw(item) {

                let jsondata = {
                    'postdata': {
                        'act': 'tea_t_work_detail', 'id': this.isteaview ? item.id : 0, 'data': { 'tk': this.c_options.tk }
                    }, 'msg': ''
                };
                if (!this.isteaview) {
                    jsondata.postdata.data.stuid = this.stuid;
                    jsondata.postdata.data.topicid = item.id;
                }
                this.$common.post(jsondata, res => {
                    this.infodatahw = res.infodata;
                    this.infodatatopic = res.infodatatopic;
                    this.topicid = this.infodatatopic.id;
                    this.isshowdialog = true;

                    if (this.isteaview) {
                        let cwork = this.$common.basic.fffind(this.infolist, 'id', item.id);
                        if (this.$common.basic.isobjexist(cwork)) {
                            cwork.x_hw = res.infodata;
                        }
                    }
                });
            },
            upattach(v) {
                if (v) {
                    if (v.indexOf('blob:http') < 0) {
                        let jsondata = {
                            'postdata': { 'act': 'tea_learn_hw', 'id': this.topicid, 'data': { 'attach': v } }, 'msg': ''
                        };
                        this.$common.post(jsondata, res => {
                            this.infodatahw = res.infodata;
                            this.curtopic.x_hw = res.infodata;
                        });

                    }
                }

            },
            workmark: function () {
                if (this.infodatahw.conmark) {
                    let jsondata = {
                        'postdata': { 'act': 'tea_t_work_submit', 'id': this.infodatahw.id, 'data': { 'conmark': this.infodatahw.conmark } }, 'msg': 'saving'
                    };
                    this.$common.post(jsondata, () => {
                        this.getdata();
                        this.isshowdialog = false;
                    });
                }
                else {
                    this.$common.alert('markempty');
                }
            }

        }
    }

</script>
